//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('unit', {
//        templateUrl: 'views/components/views/unit/unit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'unitService', function ($stateParams, stateService, utilityService, modalService, translateService, unitService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let unitNo = $stateParams.unit_no;
            
//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                propertyClassesButtons: [
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('propertyclasses') }
//                ],
//                edit: {
//                    base_unit_name: ''
//                },
//            	selectListPropertyClasses: [],
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await unitService.getEdit({ unit_no: unitNo }))[0];
//            }

//            async function loadPropertyClasses() {
//                vm.model.selectListPropertyClasses = await unitService.listPropertyClasses();
//            }

//            async function findBaseUnitName() {
//                let baseUnitName = vm.model.selectListPropertyClasses.find((item) => item.propertyclass_id === vm.model.edit.propertyclass_id)?.base_unit_name ?? '';
                
//                if (baseUnitName > '') {
//                    vm.model.edit.base_unit_name = baseUnitName;
//                } else {
//                    vm.model.edit.base_unit_name = '';
//                }
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                unitService.saveObj(vm.model.edit).then(function () {
//                    stateService.back();
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    unitService.deleteItem({ unit_no: vm.model.edit.unit_no }).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL
            
//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'propertyclass_id':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.propertyclass_id) !== true) return;

//                        vm.model.edit.propertyclass_id = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.propertyclass_id) !== true) return;
                        
//                        findBaseUnitName();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                await loadPropertyClasses();
//                findBaseUnitName();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
